import { useState } from "react";
import { mastheadNav } from "@/mocks/homeData";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="border-b border-background-200">
        <div className="flex h-9 items-center justify-between px-4 font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500 md:px-10">
          <span>2026 年 9 月 11 日 · 星期五</span>
          <span className="hidden sm:block">今日热点实时更新 · 站内新消息同步中</span>
          <span className="flex items-center gap-2 text-primary-600">
            <i className="ri-flashlight-fill" />
            实时
          </span>
        </div>
      </div>

      <div className="flex h-16 items-center justify-between gap-4 px-4 md:h-20 md:px-10">
        <a href="#top" className="group flex cursor-pointer items-end gap-3">
          <h1 className="font-heading text-2xl font-black tracking-tight text-foreground-950 transition-colors group-hover:text-primary-600 md:text-3xl">
            黑料总站
          </h1>
          <span className="hidden pb-1 font-label text-[10px] uppercase tracking-[0.35em] text-foreground-400 sm:block">
            Gossip Central
          </span>
        </a>

        <nav className="hidden items-center gap-7 font-label text-sm font-medium text-foreground-700 lg:flex">
          {mastheadNav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="relative cursor-pointer py-1 transition-colors after:absolute after:-bottom-0.5 after:left-0 after:h-px after:w-0 after:bg-primary-500 after:transition-all hover:text-primary-600 hover:after:w-full"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#topics"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-fire-line" />
            今日热点
          </a>
          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="flex flex-col border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          {mastheadNav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="cursor-pointer border-b border-background-100 py-2.5 text-sm text-foreground-700 transition-colors last:border-0 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}